// [PURPOSE]: Centralized z-index hierarchy for consistent modal/overlay layering
// [WHY]: 9+ competing z-index scales caused modals appearing behind others
// [INTEGRATION]: Import Z constant and use style={{ zIndex: Z.CONSTANT }}

export const Z = {
  NAV_BAR: 40,
  STATUS_BAR: 45,
  DROPDOWN: 50,
  NAV_MENU: 50,
  MODAL: 60,
  AUTH_MODAL: 70,
  VAULT_MODAL: 80,
  CONTAINER_MODAL: 90,
  CONTAINER_OVER_VAULT: 100,
  CONTEXT_MENU_BACKDROP: 109,
  CONTEXT_MENU: 110,
  TUTORIAL: 140,
  TUTORIAL_SPOTLIGHT: 150,
  CONFIRM_DIALOG: 160,
  // [ZLAYER-DEDUPE 2026-07-13]: DRAG_GHOST and WELCOME both sat at 200 — a real
  // runtime collision (DRAG_GHOST consumed via this constant at App.jsx; WelcomePopup
  // renders the literal z-[200]). A floating drag cursor is conventionally topmost,
  // so DRAG_GHOST moves above WELCOME. WELCOME stays 200 to match WelcomePopup's class.
  DRAG_GHOST: 210,
  WELCOME: 200,
  CONFETTI: 9999,
};
